import { LangLocale } from '@myre/common-i18n';

import DeLocale from '@angular/common/locales/de';
import EnLocale from '@angular/common/locales/en';
import EnGbLocale from '@angular/common/locales/en-GB';
import EsLocale from '@angular/common/locales/es';
import FrLocale from '@angular/common/locales/fr';

// Be careful ! The file name must match the angularLocale value of the language
export const angularLocales: Record<LangLocale, any> = {
  [LangLocale.En]: EnLocale,
  [LangLocale.EnUk]: EnGbLocale,
  [LangLocale.Fr]: FrLocale,
  [LangLocale.De]: DeLocale,
  [LangLocale.Es]: EsLocale,
};
